import type { StaticImageData } from "next/image";
import textureSpeechEngine from "./textures/speech-engine.jpg";
import textureAgents1 from "./textures/agents-1.jpg";
import imageAgents1 from "./images/agents-1.png";
import textureAgents2 from "./textures/agents-2.jpg";
import imageAgents2 from "./images/agents-2.png";
import textureAgents3 from "./textures/agents-3.jpg";
import imageAgents3 from "./images/agents-3.png";
import textureAgents4 from "./textures/agents-4.jpg";
import imageAgents4 from "./images/agents-4.png";
import textureAgents5 from "./textures/agents-5.jpg";
import imageAgents5 from "./images/agents-5.png";
import textureAgents6 from "./textures/agents-6.jpg";
import imageAgents6 from "./images/agents-6.png";
import textureAgents7 from "./textures/agents-7.jpg";
import imageAgents7 from "./images/agents-7.png";
import textureAgents8 from "./textures/agents-8.jpg";
import imageAgents8 from "./images/agents-8.png";
import textureAgents9 from "./textures/agents-9.jpg";
import imageAgents9 from "./images/agents-9.png";
import textureCreative1 from "./textures/creative-1.jpg";
import imageCreative1 from "./images/creative-1.png";
import textureCreative2 from "./textures/creative-2.jpg";
import imageCreative2 from "./images/creative-2.png";
import textureCreative3 from "./textures/creative-3.jpg";
import imageCreative3 from "./images/creative-3.png";
import textureCreative4 from "./textures/creative-4.jpg";
import imageCreative4 from "./images/creative-4.png";
import textureCreative5 from "./textures/creative-5.jpg";
import imageCreative5 from "./images/creative-5.png";
import textureCreative6 from "./textures/creative-6.jpg";
import imageCreative6 from "./images/creative-6.png";
import textureCreative7 from "./textures/creative-7.jpg";
import imageCreative7 from "./images/creative-7.png";
import textureCreative8 from "./textures/creative-8.jpg";
import imageCreative8 from "./images/creative-8.png";
import textureCreative9 from "./textures/creative-9.jpg";
import imageCreative9 from "./images/creative-9.png";

export interface OrbTexture {
  texture: string;
  image: string | StaticImageData;
  placeholder?: string;
  saturation?: number;
  noiseOpacity?: number;
}

export const TEXTURES = {
  ["speech-engine"]: {
    texture: textureSpeechEngine.src,
    image: textureSpeechEngine,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAu0lEQVR42j1PN6qGYBDcA3oVbyB24lEsLSzszGJoBHPOoreYn28fvGIZFiZSnufwfR9RFGEYBhzHgb7vUVUViqIA2baNMAzRti3O88R934zjODKJFEWBZVmI4/ifdF0X5nnmnyRJgizL0DQNpmli33c8z4N1XdmFVFWFruswDIO7CPX3fYzbtoGCIECSJJzXdR2maeKi7/vykcgRVnVdQyxK0xRZlvGCZVn+HMqyRNM0XNR1XXiex+g4Dn5E5tZ+eZ4LSwAAAABJRU5ErkJggg==",
  },
  ["agents-1"]: {
    texture: textureAgents1.src,
    image: imageAgents1,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA00lEQVR42gHIADf/Af788OwBDv4BAP8AAPz+APv7/+Xu+wYEBAHf9v7q9/4GBAMIBQADAQAFAPj6+O/8/QsBksLN5fUQ/P3+DAT1DgLuCvvfBP/zHx84AWCfrfL6FO/kzQH01wD03QD++PwGHBseNAGw2erZ5PDGwqX04cUA+/v7/gX3+wMJChABwuf3BP7vubul5NzP6urt7O33x9fCRUBwAYKlsCce+//83Nfb1t3j+NHU4RQGGkpPXAGwwcHa3MkiKRsDBg33+Qnf2t8UCw0nJiufFm95mfw9JgAAAABJRU5ErkJggg==",
  },
  ["agents-2"]: {
    texture: textureAgents2.src,
    image: imageAgents2,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA00lEQVR42gHIADf/AaTX9vX+//n7+/r8/QcFBQgHBhMQBwYGAAG40ML4/vrY7gTx+gkGBwsFBgz3/f8ODhAB0M19+AMPw9744Oz75fIA7/sK8wEQBQwYAa+6dxkeNubzAODt9eHv//D8DgwPHAgJEAFnmHBBNEkJChTt9v/x/AoFBxQPDA8JBwUBJ4qTUC4pHhQa/gEJAgUOEwwQFA0C+P0AAQCUykQWBDAYEAIDCgcHCxkMCfj8/dbv+AEJmtX5BgYvDQcOBgYNBwMJBAPh9fr4/fvW1091MDYl8wAAAABJRU5ErkJggg==",
  },
  ["agents-3"]: {
    texture: textureAgents3.src,
    image: imageAgents3,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA00lEQVR42gHIADf/AY+nqigC1BUODPoJH/IBEPD6BOHXyvTl1AHFt58bDwP+CRX1AxDxAA3x+wfz9PPq38wB4MGh/hQq9w8j/gUK+f8F9Pr++Pr4/PfvAa+jiPshSQIQHgICBPf7/PX49vn7+Q0IBgGjpGbnDFP5Bx38/gD2+ff3+PQBAQEICA0BtbJP4PtI3/YY9Pn+9Pn5+Pz9/QIN8/wHAW6KKRELOfQCJOz1/ez4BPX/D+v2BOfw7wFTfCzu7wkKCyLzARbv/xbz/g/v8fAE9u0AR247CjF7fQAAAABJRU5ErkJggg==",
  },
  ["agents-4"]: {
    texture: textureAgents4.src,
    image: imageAgents4,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA00lEQVR42gHIADf/AQCPzr9PEEAhBOfz/MPo/bbe+q/e+/P3/wE3ndCYRAsiEwPh9f7F5/zC5Pj39vzm/AgBXK7USyMGAQP/8fr8/Pb0FPnsIwj4/g4ZASad00YgBi4SABIC+BX87hv75xoG9QYPEgEAndVsIQY2FgAXA/cV//AaAesPAvH6AQEBkcrT3/oLJg7/Gwj6IQf0GgXsB/7w+AUPAdnfr6jpKAYHCSIN/CIM+xsF8AYFAfkGDwHX15vB9CrK+BsiDgEsE/0rDvkLBwH3/v9KKF5SW4ID0gAAAABJRU5ErkJggg==",
  },
  ["agents-5"]: {
    texture: textureAgents5.src,
    image: imageAgents5,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAzElEQVR42gXBTWvCMBgA4DfJm6Rpqu1WHWwwZOzSHYY3/5B3L968+8O8KOJZQRG/EEVQi1bF1Jr6PKQ9tpaQu4UnAKcgADiFLAd0kExis0+tROZxIgEyc88gJ43ubrC79C5WUyopdVkWObdIGSznUzSkmPKAQEnAjwe1ch7JE1b1Kg3cClMS6XeAf5/er694mmCFb31fH5QnHB68F0phKIQzXB7x8favz/2Pgnm67kNpJvUijjuzGau3mqPN/JwsE1m8slDpr/FmvY73L1rpSUXsGZ5aAAAAAElFTkSuQmCC",
  },
  ["agents-6"]: {
    texture: textureAgents6.src,
    image: imageAgents6,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA0UlEQVR42gXBy2rCQBQA0HudO5lJH8Q0Wkr9tP5Tt4X+QdtNF4U+UCjUoquIoIuAGlDB+ECjDo6Jw8Rz8OE1qjnFfKsu4FjmYIH+105TAdY7sdCL8WpvbMGJq0LEB1FfEW667yc1A+JMeoa8tb2aatGaEybNRzBL16+BW81YeW+vl7kME8Qkaui060iJ8tbQTVaqpMb9GeYYxWGuRmB1iXvAKyjuRil7DhV+dn63m4l/SQZEwXyk4KOvn3oK39pf338NziCo3jsimO3clwFkGZ4BFCVgVjPO7NUAAAAASUVORK5CYII=",
  },
  ["agents-7"]: {
    texture: textureAgents7.src,
    image: imageAgents7,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA00lEQVR42gHIADf/ATiLpenx+vrozgvy2gj77QH/+x4eFh4cFQEoiKr88Or85coF8N0F/PEB//0FCQ8NFBoBZazN5N/P8di3/PHo/vv4/v8B9vj+9/8LAbng8snMtNfPsPjz8/b09vDx+O/w9vP0+AG94OP37c3U1LTl5+fo6fTn6ffv8fnw7vgBa5eKPS0J8+/W4eXm5On17vEE8vMF4dvmAR8+KE5SNxkYBPDy/Pr/F/8BE+jn9dTMxAE7Tj4LGhUsNDIWFR8NDhr7/wrPzMbg18h7rn8hfgUX0wAAAABJRU5ErkJggg==",
  },
  ["agents-8"]: {
    texture: textureAgents8.src,
    image: imageAgents8,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA00lEQVR42gHIADf/Abbn7A0E9//86gP/8v39+vr9CuTl3/jv2QGUzcgH+dkRDAARDQsICBIIByMIBhAA+/QBYJ6GC/7PGxcVGRYmGRc5EhIwBwcGCwQAAWSdeQkE7RQTGhERJA4RLgkMJfr/CPr7+gFvq5gPCgEICxMHChoACB70/RLt9wHv8usBW6nDMyIXAwQG+AAM8fsK4vH/4e7u9evTASuSxU0xLRkSDPD3AePw+t3s7d7VvAjuxAEmj8MiGB4oGhj7/f/k8PHY1cXy0ZoNDQzuqlgJqjWpkAAAAABJRU5ErkJggg==",
  },
  ["agents-9"]: {
    texture: textureAgents9.src,
    image: imageAgents9,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAz0lEQVR42gXBTUrDQBQA4Hl5aSbJjKkNVANSXBQ3XsCLegs34gUCggshIIJYUemiDf2htNOSdIZ0Mnn9Pphat1TKHeZjPF5zhlHMfCBbw8t/oavZoDVjHoyEDC7STmQQDnD0gO4wCfWy01tTq6PWaxtu/BtM77jwGhF5gC35hrhlnJSTvqRvgff9uJellCXYl5YFO2i+4On1cUhvQ6mvkkjGyclLVzoq5gSbrnPVB9bPPWz2p2ZRtflPm5cJVEScMeNKZYrf8j3/nOR/l8Bvz8kHY2L/3mxfAAAAAElFTkSuQmCC",
  },
  ["creative-1"]: {
    texture: textureCreative1.src,
    image: imageCreative1,
    saturation: 1.25,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAuElEQVR42gXBvW7CMBQG0PvdGztxXaFkqNq5S5+xa8dKHcpLwAALIyMSEuJFkBB/coCI2LnmHIT5CkOrpHs7Giqn1r5KbpziulxnoZvSEVVR2U6sMpcx4r7ZJut6MTeSnphSdPdWYkSYzFAK+yozDzFR/xCj8lbj/PtPRYI37AUvxI2Tj3f2NU4/32TAI4PacONQ+tyxhh3C9E8PB4LCO+IiXyPZc/EJtIsxadZwoUdHnOCT+fJcmyddTEwcOhaLVQAAAABJRU5ErkJggg==",
  },
  ["creative-2"]: {
    texture: textureCreative2.src,
    image: imageCreative2,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAIAAAC6O5sJAAAAm0lEQVR42gXByQ3CMBAAwF0fScghhU/EE0qgKf40RF10EKE8LMdgx8d6mUH7egAq0I0YBU4jdj34ZN5BPu83yRHRMxzIP2CPkKrPgnRj1pi2xOaoxldjyZru5MV0HeSknCl1B3bIe8du5FhEzakdJmzmWGcqC+ULxYW+gyqWNnfOuu9AitIqlFgrhZNaP9Rqb4OAzCEkj21mBtZ/RVBdn8qkilAAAAAASUVORK5CYII=",
  },
  ["creative-3"]: {
    texture: textureCreative3.src,
    image: imageCreative3,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAsElEQVR42gXBO27CQBQF0HfffG15IsBSkJImTYqU6dKli5TtJMtgmyBBAaIxeMYeX87BsvvG+wdf3iS18JHwwiB8UolRNMpMlMoyYwa0gU9Wtr00CVl5y+BCDdUjd06l7+hbDoqz1qMfjvFyivuDU4mtiCCTdzONvhRfC8ZsFJeCYeSYZVpAWq0WywRn/j+/HKtWIzSmCS64efV87bbm7+fXqrOrIOtO1kk3vWxes0sPj6VHNlANDN8AAAAASUVORK5CYII=",
  },
  ["creative-4"]: {
    texture: textureCreative4.src,
    image: imageCreative4,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAy0lEQVR42gXBwS7EUBQA0Pvubd9UtSpFmARBYuMDbG18BVsSY0l8lI0/sZPYWEmIViedad7M7evc3s45wevbRxCVYN/n9Vfx//dTzrbi5Hy8S7cPL1EiqgUvy7qZFQ1XizYaVkG2vw3quFIW9SIZDqrdtHEYGG9MN1Bsws3Mji42hutUL63Q3eMkBFbVrnXWu8PenZE/CJWeJ/fWjlARe7XCO+rG4BIierq5ytMcVDNY5cCpzPekAozRtHXOnyfyfdr/HhMfoY+gA8Q1nbtj9gWKHmMAAAAASUVORK5CYII=",
  },
  ["creative-5"]: {
    texture: textureCreative5.src,
    image: imageCreative5,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAvklEQVR42gXBvU7CYBgF4HO+trSFD5FSJUTj4BXovWriIGripKObowlO3AGsJAz8JEBJStO+h+fh1/tifSirqoYkIwytdtLxCb/H8+WuqmtRlEGNHBnFIT+ep5vCQZKcGqBBHMp3ybenv/IUmWhGGAJo4DHKA04+fzZl+3gKq5qBlKc2utTNdcridzxb5dtjBGO/pdtMvV4TD++o/5f9MlntOt1YWe5Cb7i40vCRNnnltlAJ9j0GqRzhH5DdnwFDpVokwyygSAAAAABJRU5ErkJggg==",
  },
  ["creative-6"]: {
    texture: textureCreative6.src,
    image: imageCreative6,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAmklEQVR42gXB2w7BQBQF0L3PGVQRIsS7//8QTz7BGwmhdQnpTGe6rcXhcmBzVPygDCiJlH4vPE+G/gERNgcryJUTkGhujK24JHfkhlozTZggjkxhS1/LatlcvpAtVWbs3TDdY7xCqGQjWAAdViF5wHij2MkKGIEC9eo7fX4BXsNroCUy81f5q+aqexsAwCdEZn4jNmzPvN+Y/Q9a0VAFCbwaQQAAAABJRU5ErkJggg==",
  },
  ["creative-7"]: {
    texture: textureCreative7.src,
    image: imageCreative7,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAu0lEQVR42gXBvU0DQRAF4H3zdj27tyY6SyBRCiKCnIgQiZQIiRYIKIAAiT6ogCoISCEADp38f/bN+Pvw9XyfsrBORStylVy9mRrBu4vL3bB2cyCCiqiBEcx4f3qd7L9FTDWVkrWWVFTbI7w8vh37T7KlBKNAE3KS2azw5OxWJA9B+1G7Mf3tYz+IG3l6fmMuW5n0Fjvjv3FlIDOvrh8+5wvz0Dl+DXMPm5BMSmybZojpY7MiPLghoBWWkQdZu0S05FvDxgAAAABJRU5ErkJggg==",
  },
  ["creative-8"]: {
    texture: textureCreative8.src,
    image: imageCreative8,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAnUlEQVR42gXBwXHCQBAEwJm73bNUspEjcwSOgIIHGZADX2LjyRsEVUjcaZZuXra7cZ3G/EqFMMINm46bPvXt2WFmDiYwJZJcpKnxtv/vfTUnEkEEgRATeDvucryhhhCgoDJVWE2/Q12/UN9QI4MGJZlmTqfDDA+IUM5yU0Et3WTffnX8LBjcWvFKKg93jHfG+Q9dC/YkkANlieGBgg9BdUWvwq9gNgAAAABJRU5ErkJggg==",
  },
  ["creative-9"]: {
    texture: textureCreative9.src,
    image: imageCreative9,
    saturation: 1,
    noiseOpacity: 0.5,
    placeholder:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAsklEQVR42hXCMU7DQBAF0P/HO15kmyhIcUGBxDUpQOIUdIiCkgOARAOHyCEoiCIl2aw9u5Pk6dFfPjY6puFau8ZVEsIuixmZ37//rkaP2qrXRvbUnSvmwv+v9abtEIQCAw0QeFuM0+96K/HAUCmAN9XUcjtP9M8fC8NeYqGw1mY6nmtKrK9vvLl1xgJBMcmJ6Uhk+vOj390zLmEz5gmlooevOvrTg68G9AuQlzFgXGLRnwDvm1Eywp7JDQAAAABJRU5ErkJggg==",
  },
} satisfies Record<string, OrbTexture>;

export type OrbTextureName = keyof typeof TEXTURES;
export type AgentOrbTextureName = Extract<OrbTextureName, `agents-${string}`>;

export const ORB_TEXTURE_NAMES = Object.keys(TEXTURES) as OrbTextureName[];
export const AGENT_ORB_TEXTURE_NAMES = ORB_TEXTURE_NAMES.filter((name): name is AgentOrbTextureName =>
  name.startsWith("agents-"),
);
